// From #57675
const defaultShapeDimensions = {
	'arrow': {
		width: 140,
		height: 110
	},
	'double-arrow': {
		width: 150,
		height: 100
	},
	'double-box-arrow': {
		width: 175,
		height: 95
	},
	'cloud': {
		height: 95
	},
	'cube': {
		width: 110,
		height: 110
	},
	'cylinder': {
		width: 100,
		height: 125
	},
	'diamond': {
		width: 120,
		height: 120
	},
	'double-curved-arrow': {
		width: 135,
		height: 135
	},
	'hexagon': {
		width: 122,
		height: 105
	},
	'left-curved-arrow': {
		width: 125,
		height: 125
	},
	'left-inward-folded-arrow': {
		width: 120,
		height: 130
	},
	'left-outward-folded-arrow': {
		width: 120,
		height: 130
	},
	'left-inward-uturn-arrow': {
		width: 120,
		height: 130
	},
	'left-outward-uturn-arrow': {
		width: 120,
		height: 130
	},
	'page': {
		width: 95,
		height: 115
	},
	'pentagon': {
		width: 116,
		height: 110
	},
	'plus': {
		width: 120,
		height: 120
	},
	'quad-arrow': {
		width: 175,
		height: 130
	},
	'quad-box-arrow': {
		width: 175,
		height: 130
	},
	'right-curved-arrow': {
		width: 125,
		height: 125
	},
	'right-inward-folded-arrow': {
		width: 120,
		height: 130
	},
	'right-outward-folded-arrow': {
		width: 120,
		height: 130
	},
	'right-inward-uturn-arrow': {
		width: 120,
		height: 130
	},
	'right-outward-uturn-arrow': {
		width: 120,
		height: 130
	},
	'right-triangle': {
		width: 110,
		height: 110
	},
	'triangle': {
		width: 120,
		height: 108
	},
	'seal': {
		width: 120,
		height: 120
	},
	'star': {
		width: 136,
		height: 130
	}
}

export default defaultShapeDimensions

defaultShapeDimensions.__filename__ = 'dashboards/widgets/shape/default-shape-dimensions.js'
